__turbopack_context__.v({
  "chip": "h6ELGG_chip",
  "content": "h6ELGG_content",
  "cta": "h6ELGG_cta",
  "footnote": "h6ELGG_footnote",
  "headline": "h6ELGG_headline",
  "image-teaser": "h6ELGG_image-teaser",
  "media": "h6ELGG_media",
  "text": "h6ELGG_text",
});
